import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      nav: {
        home: 'Home',
        products: 'Products',
        applications: 'Application Areas',
        solutions: 'Measurement Solutions',
        about: 'About Us',
        contact: 'Contact'
      },
      applications: {
        heating: 'Heating & Engineering',
        food: 'Food Safety',
        pharma: 'Pharma & Lab',
        industry: 'Industrial Maintenance'
      },
      hero: {
        title: 'Professional Measurement Technology',
        subtitle: 'Authorized Testo dealer for industrial measurement instruments',
        cta: 'Explore Products',
        contact: 'Contact Us'
      },
      event: {
        title: 'The Entire Cooling, Ventilation and Refrigeration Value Chain',
        date: '03-06 February 2026',
        location: 'Crocus Expo, Moscow - Russia',
        visitStand: 'VISIT OUR STAND',
        standNumber: 'D9091',
        register: 'REGISTER NOW',
        promo: 'Free with promo code',
        coLocated: 'Co-Located With'
      },
      stats: {
        title: 'Our Numbers',
        subtitle: 'Key figures that demonstrate our market leadership',
        experience: 'Years of Experience',
        countries: 'Countries',
        employees: 'Employees',
        customers: 'Happy Customers'
      },
      cta: {
        title: 'Ready to get started?',
        subtitle: 'Explore our wide range of professional measurement solutions.',
        browse: 'Browse Products',
        support: '24/7 Support',
        iso: 'ISO Certified',
        fast: 'Fast Delivery',
        free: 'Free Shipping'
      },
      categories: {
        thermal: 'Thermal Imaging',
        thermalDesc: 'High-precision thermal imaging for building inspection and maintenance',
        gas: 'Gas Analyzers',
        gasDesc: 'Professional flue gas analyzers for heating systems and emissions',
        climate: 'Climate Control Systems',
        climateDesc: 'Complete climate measurement solutions for HVAC applications',
        electrical: 'Electrical Measuring Instruments',
        electricalDesc: 'Reliable electrical testing and measurement instruments',
        explore: 'Explore our comprehensive range of measurement instruments'
      },
      whyChoose: {
        title: 'Why Choose Us?',
        subtitle: 'We define the standards of measurement technology',
        leader: { title: 'Market Leader', desc: 'Leading provider of measurement solutions' },
        quality: { title: 'Certified Quality', desc: 'ISO certified products and services' },
        support: { title: 'Expert Support', desc: '24/7 technical assistance' },
        solutions: { title: 'Custom Solutions', desc: 'Tailored to your specific needs' },
        presence: { title: 'Global Presence', desc: 'Serving customers worldwide' },
        innovation: { title: 'Innovation', desc: 'Cutting-edge technology' }
      },
      products: {
        precision: 'High precision measurement',
        quality: 'ISO certified quality',
        techSupport: 'Expert technical support',
        learnMore: 'Learn More',
        cta: {
          title: 'Need help choosing the right instrument?',
          subtitle: 'Our experts are here to help you find the perfect measurement solution for your needs',
          button: 'Contact Our Experts'
        }
      },
      apps: {
        subtitle: 'Measurement solutions tailored for your industry',
        features: {
          precision: 'Precision measurement instruments',
          specific: 'Industry-specific solutions',
          support: 'Expert technical support'
        },
        why: {
          title: 'Why Choose Our Solutions?',
          subtitle: 'Professional measurement technology you can trust',
          quality: { title: 'Certified Quality', desc: 'All instruments meet international standards and regulations' },
          support: { title: 'Expert Support', desc: 'Technical assistance and training for all products' },
          delivery: { title: 'Fast Delivery', desc: 'Quick turnaround times for all orders' }
        }
      },
      solutions: {
        title: 'Our Solutions',
        subtitle: 'Comprehensive measurement solutions for every industry',
        qualityTitle: 'Quality Assurance',
        qualityDesc: 'Ensure product quality and compliance',
        supportTitle: 'Technical Support',
        supportDesc: 'Expert assistance whenever you need it',
        customTitle: 'Custom Projects',
        customDesc: 'Tailored solutions for unique requirements'
      },
      sol: {
        features: {
          iso: 'ISO 17025 certified instruments',
          gxp: 'GxP compliance solutions',
          doc: 'Quality documentation',
          reg: 'Regulatory compliance support',
          t247: '24/7 technical support',
          training: 'On-site training programs',
          install: 'Installation assistance',
          maint: 'Preventive maintenance',
          needs: 'Needs assessment',
          custom: 'Custom configurations',
          sys: 'System integration',
          opt: 'Ongoing optimization'
        },
        additional: {
          title: 'Additional Services',
          subtitle: 'Comprehensive support for all your measurement needs',
          cal: { title: 'Calibration Services', desc: 'ISO 17025 accredited calibration laboratory with traceable standards', fast: 'Fast turnaround times', onsite: 'On-site calibration available', doc: 'Certificate documentation' },
          edu: { title: 'Training & Education', desc: 'Comprehensive training programs for optimal instrument utilization', ws: 'Hands-on workshops', mod: 'Online training modules', cert: 'Certification programs', best: 'Industry best practices' },
          val: { title: 'Validation & Qualification', desc: 'Complete validation services for regulated industries', iq: 'IQ/OQ/PQ protocols', gxp: 'GxP documentation', audit: 'Audit support', reg: 'Regulatory compliance' },
          sys: { title: 'System Integration', desc: 'Seamless integration with your existing systems', data: 'Data logger connectivity', cloud: 'Cloud-based monitoring', api: 'API integrations', soft: 'Custom software solutions' }

        },
        process: {
          title: 'Our Process',
          subtitle: 'Simple steps to get started',
          s1: { title: 'Consultation', desc: 'Discuss your measurement needs and challenges' },
          s2: { title: 'Assessment', desc: 'Evaluate requirements and recommend optimal solutions' },
          s3: { title: 'Implementation', desc: 'Deploy and configure instruments with training' },
          s4: { title: 'Support', desc: 'Ongoing maintenance, calibration and technical assistance' }
        },
        cta: {
          title: 'Ready to Optimize Your Measurement Processes?',
          subtitle: 'Contact our solutions team to discuss your specific requirements',
          button: 'Get Started Today'
        }
      },
      about: {
        title: 'About Us',
        subtitle: 'Your trusted partner for measurement technology',
        mission: 'Our Mission',
        missionText: 'To provide industry-leading measurement solutions that enable our clients to achieve excellence in quality, safety, and efficiency across all their operations.',
        vision: 'Our Vision',
        visionText: 'To be the premier authorized Testo dealer in the region, recognized for exceptional service, technical expertise, and commitment to customer success.',
        image: {
          title: 'Authorized Testo Dealer',
          desc: 'Serving professionals across Turkey with excellence since 2000'
        },
        values: 'Our Values',
        valuesSubtitle: 'Our commitment to excellence drives everything we do',
        expertise: 'Technical Expertise',
        expertiseText: 'Over 20 years of experience in measurement technology',
        quality: 'Quality Commitment',
        qualityText: 'ISO certified products and calibration services',
        support: 'Customer Support',
        supportText: '24/7 technical assistance and training programs',
        innovation: 'Innovation',
        innovationText: 'Latest measurement technology and smart solutions',
        why: {
          title: 'Why Work With Us?',
          p1: { title: 'Authorized Partnership', desc: 'Official Testo dealer with direct access to the latest products and technical resources' },
          p2: { title: 'Local Expertise', desc: 'Deep understanding of market requirements and industry standards' },
          p3: { title: 'Comprehensive Service', desc: 'From initial consultation to after-sales support, we\'re with you every step' },
          p4: { title: 'Competitive Pricing', desc: 'Best value for premium measurement technology with flexible payment options' },
          p5: { title: 'Technical Training', desc: 'Regular training programs to ensure you get the most from your instruments' },
          p6: { title: 'Fast Response', desc: 'Quick turnaround times for quotes, delivery, and technical support' }
        }
      },
      contact: {
        title: 'Get in Touch',
        subtitle: 'We\'re here to help with your measurement needs',
        form: {
          title: 'Send us a message',
          success: 'Message Sent!',
          successDesc: 'Thank you for contacting us. We\'ll get back to you soon.'
        },
        name: 'Name',
        email: 'Email',
        message: 'Message',
        send: 'Send Message',
        phone: 'Phone',
        address: 'Address',
        info: 'Contact Information',

        hours: 'Business Hours',
        location: 'Our Location',
        locSubtitle: 'Visit us at our Istanbul office',
        hDays: {
          monFri: 'Monday - Friday',
          sat: 'Saturday',
          sun: 'Sunday'
        },
        closed: 'Closed'
      },
      footer: {
        about: 'About Us',
        description: 'Authorized Testo dealer providing professional measurement solutions for various industries.',
        quickLinks: 'Quick Links',
        followUs: 'Follow Us',
        copy: 'Testo Authorized Dealer. All rights reserved.'
      }
    }
  },
  ru: {
    translation: {
      nav: {
        home: 'Главная',
        products: 'Продукты',
        applications: 'Сферы применения',
        solutions: 'Измерительные решения',
        about: 'О нас',
        contact: 'Контакты'
      },
      applications: {
        heating: 'Отопление и инженерия',
        food: 'Безопасность пищевых продуктов',
        pharma: 'Фармацевтика и лаборатории',
        industry: 'Промышленное обслуживание'
      },
      hero: {
        title: 'Профессиональная измерительная технология',
        subtitle: 'Авторизованный дилер Testo для промышленных измерительных приборов',
        cta: 'Изучить продукты',
        contact: 'Связаться с нами'
      },
      event: {
        title: 'Полная цепочка ценности в охлаждении, вентиляции и кондиционировании',
        date: '03-06 Февраля 2026',
        location: 'Крокус Экспо, Москва - Россия',
        visitStand: 'ПОСЕТИТЕ НАШ СТЕНД',
        standNumber: 'D9091',
        register: 'РЕГИСТРАЦИЯ',
        promo: 'Бесплатно по промокоду',
        coLocated: 'Совместно с'
      },
      stats: {
        title: 'Наши цифры',
        subtitle: 'Ключевые показатели, демонстрирующие наше лидерство на рынке',
        experience: 'Лет опыта',
        countries: 'Страны',
        employees: 'Сотрудников',
        customers: 'Довольных клиентов'
      },
      cta: {
        title: 'Готовы начать?',
        subtitle: 'Изучите наш широкий ассортимент профессиональных измерительных решений.',
        browse: 'Обзор продуктов',
        support: 'Поддержка 24/7',
        iso: 'Сертификация ISO',
        fast: 'Быстрая доставка',
        free: 'Бесплатная доставка'
      },
      categories: {
        thermal: 'Тепловизоры',
        thermalDesc: 'Высокоточное тепловизионное обследование для инспекции и обслуживания зданий',
        gas: 'Газоанализаторы',
        gasDesc: 'Профессиональные анализаторы дымовых газов для систем отопления и выбросов',
        climate: 'Системы климат-контроля',
        climateDesc: 'Комплексные решения для измерения климата в системах ОВиК',
        electrical: 'Электроизмерительные приборы',
        electricalDesc: 'Надежные приборы для электрических испытаний и измерений',
        explore: 'Изучите наш широкий ассортимент измерительных приборов'
      },
      products: {
        precision: 'Высокая точность измерений',
        quality: 'Качество, сертифицированное по ISO',
        techSupport: 'Экспертная техническая поддержка',
        learnMore: 'Подробнее',
        cta: {
          title: 'Нужна помощь в выборе прибора?',
          subtitle: 'Наши эксперты помогут вам найти идеальное измерительное решение для ваших нужд',
          button: 'Связаться с экспертами'
        }
      },
      whyChoose: {
        title: 'Почему выбирают нас?',
        subtitle: 'Мы определяем стандарты измерительных технологий',
        leader: { title: 'Лидер рынка', desc: 'Ведущий поставщик измерительных решений' },
        quality: { title: 'Сертифицированное качество', desc: 'Продукты и услуги, сертифицированные по ISO' },
        support: { title: 'Экспертная поддержка', desc: 'Техническая помощь 24/7' },
        solutions: { title: 'Индивидуальные решения', desc: 'Адаптированы под ваши нужды' },
        presence: { title: 'Глобальное присутствие', desc: 'Обслуживаем клиентов по всему миру' },
        innovation: { title: 'Инновации', desc: 'Передовые технологии' }
      },
      apps: {
        subtitle: 'Измерительные решения, адаптированные для вашей отрасли',
        features: {
          precision: 'Прецизионные измерительные приборы',
          specific: 'Отраслевые решения',
          support: 'Экспертная техническая поддержка'
        },
        why: {
          title: 'Почему выбирают наши решения?',
          subtitle: 'Профессиональная измерительная техника, которой можно доверять',
          quality: { title: 'Сертифицированное качество', desc: 'Все приборы соответствуют международным стандартам и правилам' },
          support: { title: 'Экспертная поддержка', desc: 'Техническая помощь и обучение по всем продуктам' },
          delivery: { title: 'Быстрая доставка', desc: 'Кратчайшие сроки выполнения всех заказов' }
        }
      },
      solutions: {
        title: 'Наши решения',
        subtitle: 'Комплексные измерительные решения для каждой отрасли',
        qualityTitle: 'Обеспечение качества',
        qualityDesc: 'Гарантия качества продукции и соответствия',
        supportTitle: 'Техническая поддержка',
        supportDesc: 'Экспертная помощь в любое время',
        customTitle: 'Индивидуальные проекты',
        customDesc: 'Адаптированные решения под уникальные требования'
      },
      sol: {
        features: {
          iso: 'Приборы, сертифицированные по ISO 17025',
          gxp: 'Решения для соответствия GxP',
          doc: 'Документация по качеству',
          reg: 'Поддержка соответствия нормативным требованиям',
          t247: 'Техническая поддержка 24/7',
          training: 'Программы обучения на месте',
          install: 'Помощь в установке',
          maint: 'Профилактическое обслуживание',
          needs: 'Оценка потребностей',
          custom: 'Индивидуальные конфигурации',
          sys: 'Системная интеграция',
          opt: 'Постоянная оптимизация'
        },
        additional: {
          title: 'Дополнительные услуги',
          subtitle: 'Комплексная поддержка для всех ваших измерительных нужд',
          cal: { title: 'Услуги по калибровке', desc: 'Аккредитованная по ISO 17025 калибровочная лаборатория с прослеживаемыми стандартами', fast: 'Быстрые сроки выполнения', onsite: 'Доступна калибровка на месте', doc: 'Документация сертификатов' },
          edu: { title: 'Обучение и образование', desc: 'Комплексные программы обучения для оптимального использования приборов', ws: 'Практические семинары', mod: 'Модули онлайн-обучения', cert: 'Программы сертификации', best: 'Лучшие отраслевые практики' },
          val: { title: 'Валидация и квалификация', desc: 'Полные услуги валидации для регулируемых отраслей', iq: 'Протоколы IQ/OQ/PQ', gxp: 'Документация GxP', audit: 'Поддержка аудита', reg: 'Соответствие нормам' },
          sys: { title: 'Системная интеграция', desc: 'Бесшовная интеграция с вашими существующими системами', data: 'Подключение даталоггеров', cloud: 'Облачный мониторинг', api: 'Интеграция API', soft: 'Индивидуальные ПО-решения' }

        },
        process: {
          title: 'Наш процесс',
          subtitle: 'Простые шаги для начала работы',
          s1: { title: 'Консультация', desc: 'Обсуждение ваших потребностей и проблем в области измерений' },
          s2: { title: 'Оценка', desc: 'Оценка требований и рекомендация оптимальных решений' },
          s3: { title: 'Реализация', desc: 'Внедрение и настройка приборов с обучением' },
          s4: { title: 'Поддержка', desc: 'Постоянное техническое обслуживание, калибровка и помощь' }
        },
        cta: {
          title: 'Готовы оптимизировать ваши измерительные процессы?',
          subtitle: 'Свяжитесь с нашей командой по решениям, чтобы обсудить ваши специфические требования',
          button: 'Начать сегодня'
        }
      },
      about: {
        title: 'О нас',
        subtitle: 'Ваш надежный партнер в области измерительных технологий',
        mission: 'Наша миссия',
        missionText: 'Предоставлять лучшие в отрасли измерительные решения, позволяющие нашим клиентам достигать совершенства в качестве, безопасности и эффективности всех их операций.',
        vision: 'Наше видение',
        visionText: 'Быть ведущим авторизованным дилером Testo в регионе, признанным за исключительный сервис, техническую экспертизу и приверженность успеху клиентов.',
        image: {
          title: 'Авторизованный дилер Testo',
          desc: 'Профессиональное обслуживание клиентов по всей Турции с 2000 года'
        },
        values: 'Наши ценности',
        valuesSubtitle: 'Наша приверженность совершенству движет всем, что мы делаем',
        expertise: 'Техническая экспертиза',
        expertiseText: 'Более 20 лет опыта в области измерительных технологий',
        quality: 'Приверженность качеству',
        qualityText: 'Продукты и калибровочные услуги, сертифицированные по ISO',
        support: 'Поддержка клиентов',
        supportText: 'Круглосуточная техническая помощь и программы обучения',
        innovation: 'Инновации',
        innovationText: 'Новейшие измерительные технологии и умные решения',
        why: {
          title: 'Почему стоит работать с нами?',
          p1: { title: 'Авторизованное партнерство', desc: 'Официальный дилер Testo с прямым доступом к новейшим продуктам и ресурсам' },
          p2: { title: 'Местная экспертиза', desc: 'Глубокое понимание требований рынка и отраслевых стандартов' },
          p3: { title: 'Комплексное обслуживание', desc: 'От начальной консультации до послепродажной поддержки — мы с вами на каждом этапе' },
          p4: { title: 'Конкурентное ценообразование', desc: 'Лучшее соотношение цены и качества для премиальной измерительной техники' },
          p5: { title: 'Техническое обучение', desc: 'Регулярные программы обучения для максимальной эффективности ваших приборов' },
          p6: { title: 'Быстрая реакция', desc: 'Кратчайшие сроки подготовки предложений, доставки и поддержки' }
        }
      },
      contact: {
        title: 'Свяжитесь с нами',
        subtitle: 'Мы здесь, чтобы помочь с вашими измерительными потребностями',
        form: {
          title: 'Отправьте нам сообщение',
          success: 'Сообщение отправлено!',
          successDesc: 'Спасибо за обращение. Мы свяжемся с вами в ближайшее время.'
        },
        name: 'Имя',
        email: 'Электронная почта',
        message: 'Сообщение',
        send: 'Отправить сообщение',
        phone: 'Телефон',
        address: 'Адрес',
        info: 'Контактная информация',

        hours: 'Рабочие часы',
        location: 'Наше местоположение',
        locSubtitle: 'Посетите наш офис в Стамбуле',
        hDays: {
          monFri: 'Понедельник - Пятница',
          sat: 'Суббота',
          sun: 'Воскресенье'
        },
        closed: 'Закрыто'
      },
      footer: {
        about: 'О нас',
        description: 'Авторизованный дилер Testo, предоставляющий профессиональные измерительные решения для различных отраслей.',
        quickLinks: 'Быстрые ссылки',
        followUs: 'Подписывайтесь',
        copy: 'Официальный дилер Testo. Все права защищены.'
      }
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;